import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@src/service";
import { IGetDronesResponse, IGetPaginatedDronesRequest, IGetPaginatedDronesResponse } from "./types";

export const baseDroneApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'baseDroneApi',
  tagTypes: ['GetDrones', 'GetDroneHistory', 'GetDroneMaintenance'],
  endpoints: (builder) => ({
    getDrones: builder.query<IGetDronesResponse, void>({
      query: () => ({
        url: '/api/v1/drone',
        method: 'GET',
      }),
      providesTags: ['GetDrones'],
    }),
    getPaginatedDrones: builder.query<IGetPaginatedDronesResponse, IGetPaginatedDronesRequest>({
      query: ({ page, size, sort }) => ({
        url: '/api/v1/drone',
        method: 'GET',
        params: {
          page,
          size,
          sort,
        },
      }),
      providesTags: ['GetDrones'],
    }),
  })
});

export const { useGetDronesQuery, useGetPaginatedDronesQuery } = baseDroneApi;